import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestClientBase, RestData } from '@dibsondance/shared-rest-client-base';

import { Host } from './models/host.model';

@Injectable()
export class HostApiService extends RestClientBase {
  /**
   * Get all hosts for current user
   * API returns: { data: [ { id, name }, ... ] }
   * RestClientBase automatically unwraps RestData<Host> to Host[]
   */
  getUserHosts(): Observable<Host[]> {
    return this.get<RestData<Host>>('hosts');
  }
}
